/**
 * Settings page with import/export sections using shadcn/ui Tabs
 */

import { SectionErrorBoundary } from '@/components/common/SectionErrorBoundary'
import { CSVExportButton } from '@/components/import-export/CSVExportButton'
import { CSVImportForm } from '@/components/import-export/CSVImportForm'
import { PriceCollectionTrigger } from '@/components/prices/PriceCollectionTrigger'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useState } from 'react'
import { toast } from 'sonner'

export default function Settings() {
  const [importType, setImportType] = useState<'assets' | 'sales'>('assets')

  return (
    <div className="container mx-auto px-3 sm:px-4 py-4 sm:py-6 lg:py-8">
      <h1 className="text-2xl sm:text-3xl font-bold text-foreground mb-6 sm:mb-8">Cài đặt</h1>

      <Card>
        <CardHeader>
          <CardTitle>Quản lý Dữ liệu</CardTitle>
        </CardHeader>
        <CardContent>
          <Tabs className="TabsRoot" defaultValue="import">
            <TabsList className="TabsList">
              <TabsTrigger value="import" className="TabsTrigger">
                Import
              </TabsTrigger>
              <TabsTrigger value="export" className="TabsTrigger">
                Export
              </TabsTrigger>
              <TabsTrigger value="collection" className="TabsTrigger">
                Thu thập giá
              </TabsTrigger>
            </TabsList>

            <TabsContent value="import" className="TabsContent">
              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">Import từ CSV</h2>
                <div className="mb-4">
                  <Label htmlFor="importType" className="mb-2">
                    Loại dữ liệu
                  </Label>
                  <Select
                    value={importType}
                    onValueChange={value => setImportType(value as 'assets' | 'sales')}
                  >
                    <SelectTrigger id="importType" className="min-h-[44px]">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="assets">Tài sản</SelectItem>
                      <SelectItem value="sales">Giao dịch Bán</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <SectionErrorBoundary sectionName="Import form">
                  <CSVImportForm
                    type={importType}
                    onSuccess={() => toast.success('Import thành công')}
                    onError={error => toast.error(error)}
                  />
                </SectionErrorBoundary>
              </div>
            </TabsContent>

            <TabsContent value="export" className="space-y-6 mt-6">
              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">Export dữ liệu</h2>
                <p className="text-muted-foreground mb-4">
                  Tải xuống dữ liệu của bạn dưới dạng file CSV hoặc JSON
                </p>
                <div className="flex flex-wrap gap-4">
                  <CSVExportButton type="assets" />
                  <CSVExportButton type="sales" />
                  <CSVExportButton type="all" />
                </div>
              </div>
            </TabsContent>

            <TabsContent value="collection" className="space-y-6 mt-6">
              <SectionErrorBoundary sectionName="Price collection trigger">
                <PriceCollectionTrigger />
              </SectionErrorBoundary>
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  )
}
